import * as React from 'react';

export class NotFound extends React.Component {
    render() {
        return (
            <div className='container'>
                <h1>404 - Page not found</h1>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/notfound/notfound.component.tsx